module.exports = __webpack_public_path__ + "static/BowlsRecipeCollection-020-V2-5aaa72c0fc952670b009faefd8ad0ee1.jpg";